__turbopack_context__.v({
  "fieldset": "styles-module__qRYFJW__fieldset",
  "legend": "styles-module__qRYFJW__legend",
  "page-list": "styles-module__qRYFJW__page-list",
});
